import STORE_CONST from '../consts'
import logsApi from '../../api/logs'

const state = {
  logs: {
    loginLogs: {},
    teamLogs: {},
    clusterLogs: {},
    resourceLogs: {},
    alarmLogs: {},
    alarmNotifyUnreadCounts:0
  }
}

const mutations = {
	[STORE_CONST.LOG.LOGIN](state, log) {
		state.logs.loginLogs = log
	},
	[STORE_CONST.LOG.TEAM](state, log) {
		state.logs.teamLogs = log
	},
	[STORE_CONST.LOG.CLUSTER](state, log) {
		state.logs.clusterLogs = log
	},
	[STORE_CONST.LOG.RESOURCE](state, log) {
		state.logs.resourceLogs = log
	},
	[STORE_CONST.LOG.ALARM](state, notice) {
		state.logs.alarmLogs = notice
	},
	[STORE_CONST.LOG.UNREAD_COUNTS](state, counts) {
		state.logs.alarmNotifyUnreadCounts = counts
	},
}

const actions = {
  // get login logs
  [STORE_CONST.LOG.LOGIN] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.getLogin(params).then(res => {
        commit(STORE_CONST.LOG.LOGIN, res.data)
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // get team logs
  [STORE_CONST.LOG.TEAM] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.getTeam(params).then(res => {
        commit(STORE_CONST.LOG.TEAM, res.data)
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  // get cluster logs
  [STORE_CONST.LOG.CLUSTER] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.getCluster(params).then(res => {
        commit(STORE_CONST.LOG.CLUSTER, res.data)
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  // get resource logs
  [STORE_CONST.LOG.RESOURCE] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.getResource(params).then(res => {
        commit(STORE_CONST.LOG.RESOURCE, res.data)
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  // get event notice
  [STORE_CONST.LOG.ALARM] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.getAlarmLog(params).then(res => {
        commit(STORE_CONST.LOG.ALARM, res.data)
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  // handle event notice
  [STORE_CONST.LOG.HANDLE_NOTICE] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.handleEventNotice(params).then(res => {
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  // get action logs
  [STORE_CONST.LOG.ACTION] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.getActionList(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 日志解冻
  [STORE_CONST.LOG.UNFREEZE] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.unFreezeLog(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 查看日志
  [STORE_CONST.LOG.VIEW_LOG] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.viewLog(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取所有成员
  [STORE_CONST.LOG.GET_ACCOUNT_NAME] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.getAllMenber(params).then(res => {
        resolve(res.data)
      })
    })
  },
  // 获取所有资源名称
  [STORE_CONST.LOG.GET_RESOURCE_NAME] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.getAllResourceName(params).then(res => {
        resolve(res.data)
      })
    })
  },
  // 获取最新未读告警通知数量
  [STORE_CONST.LOG.GET_ALARM_NOTIFY_UNREAD_COUNTS] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.getAlarmNotifyUnreadCounts(params).then(res => {
        resolve(res.data)
      }, (err) => {
        reject(err)
      })
    })
  },

  // 关闭告警通知消息
  [STORE_CONST.LOG.CLOSE_ALARM_NOTIFY] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      logsApi.closeAlarmNotify(params).then(res => {
        resolve(res.data)
      }, (err) => {
        reject(err)
      })
    })
  }
}

const getters = {
  logs: state => {
    return state.logs
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/logs.js